import clsx from "clsx";
import { Tooltip as TooltipPrimitive } from "radix-ui";
import { useEffect, useState } from "react";

interface TooltipProps extends React.ComponentProps<typeof TooltipPrimitive.Content> {
  children: React.ReactNode;
  content: string;
  className?: string;
  isShow?: boolean; // 외부에서 제어하는 경우 사용
}

const Tooltip = ({
  children,
  content,
  isShow,
  side = "bottom",
  className,
  ...props
}: TooltipProps) => {
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = isShow !== undefined;
  const tooltipOpen = isControlled ? isShow : internalOpen;

  const handleOpenChange = isControlled ? undefined : setInternalOpen;

  useEffect(
    function initializeInternalOpen() {
      if (isShow !== undefined) {
        setInternalOpen(false);
      }
    },
    [isShow]
  );

  return (
    <TooltipPrimitive.Root
      delayDuration={0}
      open={tooltipOpen}
      onOpenChange={handleOpenChange}
    >
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>

      <TooltipPrimitive.Content
        side={side}
        sideOffset={5}
        align="center"
        avoidCollisions={true}
        collisionPadding={10}
        className={clsx(
          className,
          "z-[10] rounded-[3px] bg-line-btn px-[5px] py-[2px] text-[11px] font-medium leading-[130%] text-g-100",
          "animate-tooltip-scale-fade-in"
        )}
        {...props}
      >
        {content}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Root>
  );
};

export default Tooltip;
